import {Injectable} from '@angular/core';
import {MilitaryExperience} from './military-experience.model';
import {Service} from '../../common/service.class';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class MilitaryExperienceService extends UserModelService<MilitaryExperience> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'militaryExperience', MilitaryExperience);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/military/military-experience.service.ts